import styled from "styled-components";
export const SIZES = {
    MIN_WIDTH: 300,
    TITLE_PADDINGS: "7px 0 8px",
    ACCESS_PADDINGS: "2px 6px",
    AVATAR_SIZE: 24
};
export default {
    AccessBadge: styled.div `
    background: ${({ theme }) => theme["properties-panel-editor-bg"]};
    color: ${({ theme }) => theme["M3-sys-light-on-surface-variant;"]};
    padding: ${SIZES.ACCESS_PADDINGS};
    font-size: ${({ theme }) => theme["font-size-small"]};
    line-height: ${({ theme }) => theme["font-size-base-16"]};
    border-radius: ${({ theme }) => theme["border-radius-4"]};
    font-weight: 500;
  `
};
